export function getSessionToken(storageKey = "user") {
  try {
    const raw = sessionStorage.getItem(storageKey);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed?.token || "";
  } catch {
    return "";
  }
}

export function buildRedirectUrl(baseUrl, params = {}) {
  if (!baseUrl) return "";
  const sep = baseUrl.includes("?") ? "&" : "?";
  const query = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`)
    .join("&");
  return query ? `${baseUrl}${sep}${query}` : baseUrl;
}

// ✅ função nova "pura" pra usar em <a href="...">
export function getCondoRedirectUrl(appUrl, condominioId) {
  const token = getSessionToken();
  if (!token || !appUrl || !condominioId) return "";
  return buildRedirectUrl(appUrl, { token, condominio_id: condominioId });
}

// ✅ compatibilidade: mantém o que já existe no ListaSap
export function redirectWithTokenAndCondo({ baseUrl, condominioId }) {
  return getCondoRedirectUrl(baseUrl, condominioId);
}
